export const WIDTH = 700;
export const HEIGHT = 350;
